import { render, staticRenderFns } from "./formatStyleOptions.vue?vue&type=template&id=2001214b&scoped=true"
import script from "./formatStyleOptions.vue?vue&type=script&lang=js"
export * from "./formatStyleOptions.vue?vue&type=script&lang=js"
import style0 from "./formatStyleOptions.vue?vue&type=style&index=0&id=2001214b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001214b",
  null
  
)

export default component.exports